module.exports = __webpack_public_path__ + "cfbd9c46384b8bd12a4e67c328c7c356.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jewel_bg.png
// module id = 1146
// module chunks = 0